
import * as storyblokRuntime$KFwypxpMgSOfniT7WTnABxukVUuZ2r2ada15AHJXY9Y from '/builds/r3013/public-website-front/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxRuntime$_8WCo_45q2EO1c9sVmJ2ErHed344a7oyDohypVjzPemKow from '/builds/r3013/public-website-front/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ],
  "quality": 85
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$KFwypxpMgSOfniT7WTnABxukVUuZ2r2ada15AHJXY9Y, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['ipx']: { provider: ipxRuntime$_8WCo_45q2EO1c9sVmJ2ErHed344a7oyDohypVjzPemKow, defaults: {} }
}
        